import { AppModule } from 'app/module';
import { NotificationBar } from 'module/notificationBar/main';
import './styles.scss';

export class BaseLayout extends AppModule {
    domBindings() {
        return {
            body: 'body',
            notificationBar: '.m-notificationBar',
        };
    }

    subs() {
        if (this.dom.notificationBar) {
            this.notificationBar = new NotificationBar(this.dom.notificationBar);
        }
    }

    addModalStyle() {
        if (this.dom.body.style.overflowY !== 'hidden') {
            this.dom.body.style.overflowY = 'hidden';
        }
    }

    removeModalStyle() {
        if (this.dom.body.style.overflowY === 'hidden') {
            this.dom.body.style.overflowY = 'visible';
        }
    }
}
